import React from 'react';
import TransportationHeader from './TransportationHeader/TransportationHeader';
import TransportationTimeSection from './TransportationTimeSection/TransportationTimeSection';
import TransportationLocationSection from './TransportationLocationSection/TransportationLocationSection';
import { Moment } from 'moment-timezone';
import { ValueTypeSelectorValue } from 'components/UI/V3/Forms/ValueTypeSelector';
import TransportationPriceSection from './TransportationPriceSection/TransportationPriceSection';

interface TransportationSectionProps {
    title: string;
    service?: boolean;
    addressLabel: string;
    instructionsLabel: string;
    from?: Moment;
    to?: Moment;
    hideDate?: boolean;
    price?: number;
    discount?: ValueTypeSelectorValue;
    address?: string;
    instructions?: string;
    saveCustomPrice?: boolean;
    useSavedCustomPrice?: boolean;
    petId?: number;
    serviceId?: number;
    catalogPrice?: number;
    customPriceKind?: 'standard' | 'pickup' | 'dropoff';
    onTimeChange?: (value: { from: Moment; to: Moment }) => void;
    onPriceChange?: (value: number) => void;
    onDiscountChange?: (value: ValueTypeSelectorValue) => void;
    onAddressChange?: (value: string) => void;
    onInstructionsChange?: (value: string) => void;
    onSaveCustomPriceChange?: (checked: boolean) => void;
    onUseSavedCustomPriceChange?: (useSaved: boolean, price: number, customPriceId?: number) => void;
}

export const TransportationSection: React.FC<TransportationSectionProps> = ({
    title,
    service,
    addressLabel,
    instructionsLabel,
    from,
    to,
    hideDate,
    price,
    discount,
    address,
    instructions,
    saveCustomPrice,
    useSavedCustomPrice,
    petId,
    serviceId,
    catalogPrice,
    customPriceKind,
    onTimeChange,
    onPriceChange,
    onDiscountChange,
    onAddressChange,
    onInstructionsChange,
    onSaveCustomPriceChange,
    onUseSavedCustomPriceChange
}) => {
    return (
        <div>
            <TransportationHeader title={title} />

            <TransportationTimeSection
                from={from}
                to={to}
                hideDate={hideDate}
                onChange={onTimeChange}
            />

            {service && (
                <TransportationPriceSection
                    price={price}
                    discount={discount}
                    maxDiscount={price}
                    saveCustomPrice={saveCustomPrice}
                    useSavedCustomPrice={useSavedCustomPrice}
                    petId={petId}
                    serviceId={serviceId}
                    catalogPrice={catalogPrice}
                    customPriceKind={customPriceKind}
                    onPriceChange={onPriceChange}
                    onDiscountChange={onDiscountChange}
                    onSaveCustomPriceChange={onSaveCustomPriceChange}
                    onUseSavedCustomPriceChange={onUseSavedCustomPriceChange}
                />
            )}

            <TransportationLocationSection
                addressLabel={addressLabel}
                instructionsLabel={instructionsLabel}
                address={address}
                instructions={instructions}
                onAddressChange={onAddressChange}
                onInstructionsChange={onInstructionsChange}
            />
        </div>
    );
};
